<div>
    <div class="title" (click)="toggle()">
      <ng-content select="[title]"></ng-content>
      <i [ngClass]="collapsed ? 'dx-icon-chevrondown' : 'dx-icon-chevronup'"></i>
    </div>
  
    <div class="content" [hidden]="collapsed">
      <ng-content></ng-content>
    </div>
  </div>
  